module.exports = __webpack_public_path__ + "media/images/logo_512-5c96e77e.png";